class FetchService {
  /*
   * GET
   */
  async get(url, options) {
    let requestConfig = getBasicRequestConfig(options);
    requestConfig.method = 'get';
    let response = await fetch('/api/notifications/' + url);
    if (didRequestFail(response))
      throw createRequestFailedError(response);
    return await handleSuccess(response);
  }
  /*
   * POST
   */
  async post(url, data, options) {
    let requestConfig = getBasicRequestConfig(options);

    requestConfig.headers['Accept'] = 'application/json; charset=utf-8';
    requestConfig.headers['Content-Type'] = 'application/json; charset=utf-8';
    requestConfig.method = 'post';
    requestConfig.body = JSON.stringify(data);

    let response = await fetch('/api/notifications/' + url, requestConfig);

    if (didRequestFail(response))
      throw createRequestFailedError(response);

    return await handleSuccess(response);
  }
  /*
 * PUT
 */
  async put(url, data, options) {
    let requestConfig = getBasicRequestConfig(options);
    requestConfig.headers['Accept'] = 'application/json';
    requestConfig.headers['Content-Type'] = 'application/json';
    requestConfig.method = 'put';
    requestConfig.body = JSON.stringify(data);
    let response = await fetch('/api/notifications/' + url, requestConfig);
    if (didRequestFail(response))
      throw createRequestFailedError(response);
    return await handleSuccess(response);
  }
  /*
 * DELETE
 */
  async delete(url, options) {
    let requestConfig = getBasicRequestConfig(options);
    requestConfig.headers['Accept'] = 'application/json; charset=utf-8';
    requestConfig.headers['Content-Type'] = 'application/json; charset=utf-8';
    requestConfig.method = 'delete';
    let response = await fetch('/api/notifications/' + url, requestConfig);
    if (didRequestFail(response))
      throw createRequestFailedError(response);
    return await handleSuccess(response);
  }
}

function getBasicRequestConfig(options) {
  let includeCredentials = (options && options.includeCredentials) || false;
  let requestConfig = {
    credentials: includeCredentials ? 'same-origin' : 'omit',
    headers: {
      'no-gui-request': 'no-gui',
      'AntiForgeryToken': document.getElementsByName('__RequestVerificationToken')[0].value
    }
  };
  if (options && options.signal)
    requestConfig.signal = options.signal;
  return requestConfig;
}

function didRequestFail(response) {
  return response.status >= 400 && response.status < 600;
}

async function handleSuccess(response) {
  if (response.status === 204) // Ok, no content
    return response;
  let contentType = response.headers.get('Content-Type');
  if (!contentType || !contentType.includes('application/json'))
    return response;
  return await response.json();
}

function createRequestFailedError(response) {
  let error = new Error(`${response.status} ${response.statusText}`);
  error.status = response.status;
  return error;
}

export default new FetchService();



// WEBPACK FOOTER //
// ./src/fetchService.js